import { trustCards } from "@/data/content";
import { Reveal } from "@/components/motion";

export const TrustCards = () => (
  <section className="relative z-10 -mt-2 bg-background" aria-label="Key credentials">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="trust-cards">
        {trustCards.map((card, i) => (
          <Reveal key={card.title} delay={i}>
            <div
              data-testid={`trust-card-${card.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group bg-white rounded-2xl border border-slate-200/80 shadow-soft p-6 h-full hover:-translate-y-1 hover:shadow-lift hover:border-teal-500/30 transition-[transform,box-shadow,border-color] duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-teal-50 border border-teal-100 flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300">
                <card.icon size={20} className="text-teal-700 group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="font-serif font-semibold text-slate-900 text-lg leading-snug">{card.title}</h3>
              <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{card.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
